import React from 'react';

import './PersonalInfoSection.css';
import HoveredDropDown from '../HoveredDropDown';
import InputField from '../InputField';
import CalendarField from '../CalendarField';
import FilterSection from '../FilterSection';
import { getGenderOptions } from '../../../../constants/Genders';
import { getMaritalStatuses } from '../../../../constants/MaritalStatutes';
import { getLanguages } from '../../../../constants/Languages';
import { checkValidation, validations } from '../../../../constants/Validators';

export default (props) => {

  const onSelected = (field) => (item) => props.changeUserData(field, item);

  const changeValue = (field) => (value) => props.changeUserData(field, value);

  const { showError, title, firstName, lastName, gender, maritalStatus, dateOfBirth,
    language, occupation, occupationList } = props;
  return (
    <div className="appendBottom40 personalInfoSection">
      <p className="latoBlack font22 appendBottom20 blacktext">
        {title}
      </p>
      <div className="formDataContainer">
        <div className="makeFlex column">
          <div className="makeFlex">
            <InputField
              value={firstName}
              label="Enter your first name"
              maxLength={30}
              changeValue={changeValue('firstName')}
              error={showError && !checkValidation(firstName, validations.firstName)}
              errorMsg={'Enter a valid first name'}
            />
            <InputField
              value={lastName}
              label="Enter your last name"
              maxLength={30}
              changeValue={changeValue('lastName')}
              error={showError && !checkValidation(lastName, validations.lastName)}
              errorMsg={'Enter a valid last name'}
            />
          </div>
          <div className="makeFlex">
            <CalendarField
              label={'Select your date of birth'}
              placeholder={'Open calendar and select date'}
              type="text"
              onSelected={onSelected('dateOfBirth')}
              error={showError && !dateOfBirth}
            />
            <HoveredDropDown
              classNames={'inputFieldContainer'}
              data={occupationList}
              defaultSelected={occupation}
              labelName="Select your occupation"
              onSelected={onSelected('occupation')}
            />
          </div>
        </div>
        <FilterSection label={'Select your gender'} mode={'filters'} allFilters={getGenderOptions()} selected={gender} onSelected={onSelected('gender')} error={showError && !gender}/>
        <FilterSection label={'Select your marital status'} mode={'filters'} allFilters={getMaritalStatuses()} selected={maritalStatus} onSelected={onSelected('maritalStatus')} error={showError && !maritalStatus}/>
        <FilterSection label={'Select your preferred language'} mode={'filters'} allFilters={getLanguages()} selected={language} onSelected={onSelected('language')} error={showError && !language}/>
      </div>
    </div>
  );
};
